// @flow

import LinkReplace from 'client/components/button/linkReplace';
import Notification from 'client/components/notification';
import ScrollTo from 'client/components/scrollTo';
import Translate from 'client/components/translate';
import ROUTES from 'client/constants/routes';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import ValidationUtils from 'utils/validate';

// import { getConfigValue } from 'client/utils/configUtils';

import AccountForm from './accountForm';
import Hero from './hero';
import { sourceToPathMapping } from './routes';

// const DEFAULT_REDIRECT = '/my/insurance';
const DEFAULT_REDIRECT = ROUTES.PHASE3_DASHBOARD_ROUTE;
// sources https://docs.google.com/spreadsheets/d/1nSaebRfOU2N-FkNL97GW9xJaWdCA16gpl2X3fu3x_PQ/edit#gid=1708674038
const DEFAULT_SOURCE = 'generic-web';

const mapStateToProps = state => ({
  user: state.user,
  brandName: state.brand,
  phase3Enabled: state.phase3Enabled,
  // logoUrl: getConfigValue(
  //   state.siteConfigs,
  //   'cobrandedLogoLarge.file.url',
  //   '/assets/img/brand/stride/logo/large.png',
  // ),
});

/* eslint-disable react/no-unused-prop-types */
type Props = {
  brandName: string,
  onSubmit: Function, // from redux-form
  location: {
    query: {
      // where to redirect after auth success
      redirect?: string,
      // where the account create is originating from, e.g. 'health-onboarding'
      source?: string,
    },
    state?: {
      locationUsername?: string,
    },
  },
  isLogin?: boolean,
  formType: string,
  partnerName: string | null,
  phase3Enabled: boolean,
  // logoUrl: string,
};
/* eslint-enable react/no-unused-prop-types */

type State = {
  formData: {
    username: {
      value: string,
      error: Error | null,
    },
    password: {
      value: string,
      error: Error | null,
    },
  },
  scrollTop: boolean,
  submitFailed: boolean,
  submitFailedMessage: string | null,
};

export class Account extends Component<Props, State> {
  static defaultProps = {
    address: {},
    members: [],
    apps: [],
    onSubmit: () => {},
    isLogin: false,
    // formType: '',
  };

  constructor(props: Props) {
    super(props);
    const { location, phase3Enabled } = props;
    const initalUsername = _.get(location, 'state.locationUsername');
    let redirectQuery = _.get(location, 'query.redirect');
    const sourceQuery = _.get(location, 'query.source');

    if (redirectQuery && !ValidationUtils.validateRedirectPath(redirectQuery)) {
      redirectQuery = '';
    }
    this.redirect = redirectQuery || (phase3Enabled ? DEFAULT_REDIRECT : '/my/insurance');
    this.source = sourceQuery || DEFAULT_SOURCE;
    this.state = {
      formData: {
        username: {
          value: initalUsername || '',
          error: null,
        },
        password: {
          value: '',
          error: null,
        },
      },
      scrollTop: false,
      submitFailed: false,
      submitFailedMessage: null,
    };
  }

  onSubmit = (err, accountInfo) => {
    if (err) {
      return this.setState({
        submitFailed: true,
        scrollTop: this.needsScroll(),
        submitFailedMessage: err.message,
      });
    }

    this.setState({
      submitFailed: false,
      submitFailedMessage: null,
    });

    return this.props
      .onSubmit({
        ...accountInfo,
        redirect: this.redirect,
        source: this.source,
        partnerName: this.props.partnerName,
      })
      .catch((e) => {
        const createServerErrMsg = _.get(e, 'response.data.message', '');
        const loginServerErrStatus = _.get(e, 'status', '');
        const clientErrMsg = _.get(e, 'message', '');
        const errState = {
          submitFailed: true,
          scrollTop: this.needsScroll(),
          submitFailedMessage: 'common.error.somethingWrong',
        };
        if (clientErrMsg) {
          errState.submitFailedMessage = clientErrMsg;
        }
        if (createServerErrMsg.indexOf('exists') >= 0) {
          errState.submitFailedMessage = 'common.error.existingAccount';
        } else if (loginServerErrStatus === 'ERROR') {
          errState.submitFailedMessage = 'common.error.loginFail';
        }
        this.setState(errState);
        return { clearPassword: true };
      });
  };

  onFormUpdate = (nextFormData) => {
    this.setState({
      formData: nextFormData,
    });
  };

  getCopyPath = (prefix) => {
    const defaultPath = `${prefix}.hero.default`;
    if (this.source !== DEFAULT_SOURCE) {
      const suffix = _.find(sourceToPathMapping, (v, k) => this.source === k);
      if (suffix) {
        return `${prefix}.${suffix}`;
      }
    }
    return defaultPath;
  };

  redirect: string;
  source: string;

  needsScroll() {
    const scrollingElement = document.scrollingElement || document.documentElement;
    if (scrollingElement) {
      return scrollingElement && scrollingElement.scrollTop !== 0;
    }

    return false;
  }

  render() {
    const {
      isLogin,
      formType,
      location,
      brandName,
      // logoUrl,
    } = this.props;

    const commonPrefix = 'common.account';
    const formTypePrefix = `${commonPrefix}.${formType}`;
    const ctaPath = `${formTypePrefix}.cta`;
    const toggleTo = isLogin ? '/create' : '/login';

    const swapLinkElement = (
      <LinkReplace
        className="transparent blue-color"
        to={{
          pathname: toggleTo,
          query: location.query,
        }}
        state={{
          locationUsername: this.state.formData.username.value,
        }}>
        <Translate path={`${formTypePrefix}.changeCtaLink`} />
      </LinkReplace>
    );

    return (
      <div className="account-page">
        {/* <Hero brandName={brandName} logoUrl={logoUrl} /> */}
        <Hero brandName={brandName} />
        {this.state.submitFailed && (
          <Notification theme="red" border borderPosition="bottom">
            <div className="text-center" style={{ maxWidth: '36rem', margin: 'auto' }}>
              <h5 className="red-color">
                <Translate path="common.error.genericHeader" />
              </h5>
              <h5 className="grey-2-color light">
                <Translate path={this.state.submitFailedMessage || 'common.error.genericMessage'} />
              </h5>
            </div>
          </Notification>
        )}

        {this.state.scrollTop && (
          <ScrollTo
            to={0}
            onRest={() => {
              this.setState({
                scrollTop: false,
              });
            }} />
        )}

        <div className="center-col" style={{ paddingBottom: '4rem' }}>
          <div className="form-container medium-margin-top-2">
            <div className="center-col-small">
              <AccountForm
                ctaPath={ctaPath}
                headlinePath={this.getCopyPath(formTypePrefix)}
                submitHandler={this.onSubmit}
                changeHandler={this.onFormUpdate}
                data={this.state.formData}
                isLogin={isLogin} />
              <div className="text-center grey-3-color">
                {isLogin ? (
                  <div className="margin-2">
                    <Link
                      className="transparent"
                      to={{
                        pathname: '/request-reset',
                        query: location.query,
                      }}>
                      <Translate path={`${formTypePrefix}.resetPassword`} />
                    </Link>
                  </div>
                ) : (
                  <p className="margin-2 mini">
                    <Translate path={`${formTypePrefix}.legal`} />
                  </p>
                )}
              </div>
            </div>
          </div>
          <p className="text-center margin-top-2 pad-top-2">
            <Translate path={`${formTypePrefix}.changeCta`} /> {swapLinkElement}
          </p>
        </div>
      </div>
    );
  }
}

const AccountContainer = connect(mapStateToProps)(Account);

export default AccountContainer;
